import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitterService } from '../../../services/event-emitter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, fromEvent } from 'rxjs';
import { DeletePopupComponent } from '../../../modals/delete-popup/delete-popup.component';
import { TeamMembersService } from '../../../services/team-members.service';
import { TeamMemberPopupComponent } from '../../../modals/team-member-popup/team-member-popup.component';
import { Roles } from '../../../models/roles';
import { AuthenticationService } from '../../../services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrl: './team.component.scss',
})
export class TeamComponent implements OnInit, AfterViewInit {
  user;
  @ViewChild('searchInput') searchInput: ElementRef;
  search = '';
  teamMembers = [];
  page = 1;
  pageSize = 10;
  totalItems = 0;
  totalPages = 1;
  loading = false;
  destoryRef = inject(DestroyRef);

  constructor(
    private authenticationService: AuthenticationService,
    private teamMembersService: TeamMembersService,
    private modalService: BsModalService,
    public eventEmitterService: EventEmitterService,
  ) {
    this.eventEmitterService.invokeEvent
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((event) => {
        if (event == 'call-all-team-members') {
          this.resetPagination();
          this.getAllTeamMembers();
        }
      });
  }

  ngOnInit() {
    this.getUser();
    this.resetPagination();
    this.getAllTeamMembers();
  }

  ngAfterViewInit(): void {
    this.setupSearch();
  }

  async getUser() {
    this.user = await this.authenticationService.getUserFromToken();
  }

  resetPagination() {
    this.teamMembers = [];
    this.page = 1;
    this.pageSize = 10;
    this.totalItems = 0;
    this.totalPages = 1;
  }

  getAllTeamMembers() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    const apiData: any = {
      page: this.page,
      pageSize: this.pageSize,
    };

    if (this.search && this.search.trim().length > 0) {
      apiData.search = this.search;
    }
    this.teamMembersService.getAllTeamMembers(apiData).subscribe(
      (response: any) => {
        this.loading = false;

        this.teamMembers = response.items;
        this.page = response.page;
        this.pageSize = response.pageSize;
        this.totalItems = response.totalItems;
        this.totalPages = response.totalPages;

        this.teamMembers.forEach((item) => {
          if (item.role == Roles.Rider && item.rider) {
            item.name = item.rider.name;
            item.email = item.rider.email;
          } else {
            item.name = `${item.firstname} ${item.lastname}`;
          }
        });

        console.log('this.teamMembers:');
        console.log(this.teamMembers);
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.loading = false;
      },
    );
  }

  setupSearch() {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(debounceTime(3000))
      .subscribe((event: Event) => {
        this.resetPagination();
        this.getAllTeamMembers();
      });
  }

  setSearch(event: any) {
    this.search = event.target.value;
  }

  onPageChange(event: { page: number; pageSize: number }) {
    this.page = event.page;
    this.pageSize = event.pageSize;
    this.getAllTeamMembers();
  }

  addTeamMember() {
    this.modalService.show(TeamMemberPopupComponent, {
      initialState: {
        title: 'new-team-member',
        type: 'new-team-member',
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  editTeamMember(teamMember) {
    this.modalService.show(TeamMemberPopupComponent, {
      initialState: {
        title: 'edit-team-member',
        type: 'edit-team-member',
        teamMember: teamMember,
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  deleteTeamMemberPopup(id) {
    this.modalService.show(DeletePopupComponent, {
      initialState: {
        title: 'delete-team-member',
        text: 'delete-team-member-text',
        id: id,
        onButtonClick: this.deleteTeamMember.bind(this),
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  async deleteTeamMember(id): Promise<void> {
    console.log('delete team member id:');
    console.log(id);
    return new Promise((resolve, reject) => {
      this.teamMembersService.deleteTeamMember(id).subscribe(
        (response) => {
          console.log('response:');
          console.log(response);
          this.eventEmitterService.callAllTeamMembers();
          resolve();
        },
        (error) => {
          console.log('error:');
          console.log(error);
          reject();
        },
      );
    });
  }
}
